'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './reservation-list.routes';

export class ReservationListComponent {

  constructor(ReservationService, $uibModal, $timeout, Auth, $state, Config, dialogs) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.ReservationService = ReservationService;
    this.Auth = Auth;
    this.eventSources = [];
    this.$uibModal = $uibModal;
    this.dialogs = dialogs;
    this.$timeout  = $timeout;
    this.isAdmin = Auth.isAdminSync;

    var generalConfig = Config.getModuleConfig(Config.Modules.General);

    this.types = Config.getModuleConfig(Config.Modules.Reservation).getTypes();
    this.config = Config.getModuleConfig(Config.Modules.Reservation).getSettings();

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, this.config[this.type].name + " Reservation");

    this.hours = false;

    if (this.config[this.type].hasOwnProperty("hours")) {
      this.hours = this.config[this.type].hours;
    }

    if (this.config[this.type].hasOwnProperty("customSchema")) {
      this.customSchema = this.config[this.type].customSchema;
    }

    this.timezone = generalConfig.getClientTimezone();

    var eventSourceTaken = {
      events: [],
      color: '#ffcc66',
      textColor: 'black'
    };

    var eventSourceToBeApproved = {
      events: [],
      color: '#aa0000',
      textColor: 'white'
    };

    var eventSourceApproved = {
      events: [],
      color: '#00aa00',
      textColor: 'white'
    };

    this.eventSources.push(eventSourceTaken);
    this.eventSources.push(eventSourceToBeApproved);
    this.eventSources.push(eventSourceApproved);

    this.takenIds = [];
    this.toBeApprovedIds = [];
    this.approvedIds = [];

    this.reservations = [];

    var that = this;

    var getData = function() {

      ReservationService.getUpcomingByUserAndType({userId: that.Auth.getCurrentUserSync()._id, type: that.type}, data => {
        that.upcomingReservations = data;

        if (that.eventSources.length && that.eventSources[1].events.length) {
          that.eventSources[1].events.splice(0, that.eventSources[1].events.length);
        }

        data.forEach(evt => {
          if (evt.state == 'toBeApproved') {
            that.toBeApprovedIds.push(evt._id);
            evt.title = "Not yet approved";
            that.eventSources[1].events.push(evt);
          } else if (evt.state == 'accepted') {
            that.approvedIds.push(evt._id);
            evt.title = "Reserved for you";
            that.eventSources[2].events.push(evt);
          }
        });

        ReservationService.getByTypeAndState({type: that.type, state: 'accepted'}, data => {

          that.reservations = data;

          if (that.eventSources.length && that.eventSources[0].events.length) {
            that.eventSources[0].events.splice(0, that.eventSources[0].events.length);
          }

          data.forEach(evt => {
            // Do not at my own approved reservations, as there is another eventSource for this
            if (that.approvedIds.indexOf(evt._id) == -1) {
              evt.title = "Taken";
              that.eventSources[0].events.push(evt);
            }
          });

        }, err => {
          console.log('could not retrieve reservations from server');
        });
      });

      ReservationService.getPastByUserAndType({userId: that.Auth.getCurrentUserSync()._id, type: that.type}, data => {
        that.pastReservations = data;
      });
    };

    this.getData = getData;
    getData();

    this.uiConfig = {
      calendar: {
        defaultView: 'agendaWeek',
        allDaySlot: false,
        minTime: '06:00:00',
        slotDuration: '00:60:00',
        height: 'auto',
        timezone: 'local',
        businessHours: this.hours,
        header: {
          left: 'title',
          center: 'month,agendaWeek',
          right: 'today prev,next'
        },
       viewRender: (view, el) => {
         /* This is a hack, because the stick property of the event doesn't work with recurring events,
         so that these will appear multiple times per day - that's a bug.
         This hack solved the stick issue without using stick itself and thus corrupting recurring events:
         https://github.com/angular-ui/ui-calendar/issues/276 */

         jQuery('#fullCalendar').fullCalendar('removeEvents');
         this.eventSources.forEach(eventSource => {
          jQuery('#fullCalendar').fullCalendar('addEventSource', eventSource);
         })
        },
        eventRender: (event, el) => {
          // Timezone Difference Info
          var timeZoneDiffMin = this.getTimezoneDifference(this.timezone);

          var getTimezoneDiffString = function(mins) {
            var prefix = "+";
            if (mins < 0)
              prefix = "-";

            mins = Math.abs(mins);

            var h = mins / 60 | 0,
                m = mins % 60 | 0;

            if (String(h).length == 1)
              h = "0" + String(h);

            if (String(m).length == 1)
              m = "0" + String(m);

            return prefix + String(h) + ":" + String(m);
          };

          var timeZoneDiffStr = getTimezoneDiffString(timeZoneDiffMin);

          // render the timezone offset below the event title, if
          // user is in other timezone and the event is not all day
          if (!event.allDay && timeZoneDiffMin != 0) {
            el.find('.fc-title').after(
              jQuery('<div class="tzo text-muted"/>').text( timeZoneDiffStr )
            );
          }
        }
      }
    };
  }

  openAddReservationModal() {
    var that = this;

    let now = new Date();
    let ranges = [];

    that.reservations.forEach(reservation => {
      // only look at the events which are in the future;
      // events in the past are not allowed to create anyway
      if (new Date(reservation.end) > now) {
        ranges.push({
          start: new Date(reservation.start),
          end: new Date(reservation.end)
        })
      }
    });

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'reservationAdd',
      resolve: {
        config: function() {
          return {
            takenDateRanges: ranges,
            customSchema: that.customSchema
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function (reservation) {
        reservation.type = that.type;
        that.ReservationService.save(reservation, _ => that.getData());
      },
      function () { /* cancel */ }
    );

  }

  userContributionAllowed() {
    return this.calendarEventUserContributionAllowed
      && this.calendarEventUserContributionAllowed.indexOf(this.type) !== -1;
  }

  getTimezoneDifference(targetTimezone, userTimezone) {
    var now = moment();

    if (typeof userTimezone != 'undefined') {
      now = moment.tz(userTimezone);
    }

    var localOffset = now.utcOffset();

    now.tz(targetTimezone);

    var centralOffset = now.utcOffset();
    var diffInMinutes = localOffset - centralOffset;

    return diffInMinutes;
  }

  cancel(reservation) {
    var that = this;

    var reservationText = "<br/><br/><b>" + moment(reservation.start).format('MMMM Do YYYY, h:mm')
      + "</b> till <b>" + moment(reservation.end).format('MMMM Do YYYY, h:mm') + "</b>";

    var dlg = this.dialogs.confirm("Cancel Reservation?", "Do you really want to cancel your reservation?" + reservationText);
    dlg.result.then(() => {
      // OK delete it
      that.ReservationService.delete({id: reservation._id},
        () => {
          that.getData();
        },
        err => {
          alert("Could not cancel reservation");
        });
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduuApp.reservationList', [uiRouter])
  .config(routes)
  .component('reservationList', {
    template: require('./reservation-list.html'),
    controller: ReservationListComponent,
    bindings: {
      type: '@'
    },
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/reservation/amenity/list/reservation-list.component.js